
import { defineComponent, ref } from "vue";
import { LinkageItem } from "@/modules/linkage/linkageInfo";
import { useStore } from "@/store";


export default defineComponent({
    name: "LinkageGeneralError",
    props: {
        message: { type: String },
    },
    setup(props) {
        const store = useStore();
        const { linkageInfo, siteDefaultCallbackUrl } = LinkageItem.inject();
        const siteInfo = store.state.siteLinkage.find((site: any) => site.link_id === linkageInfo.linkageId)!;

        const messageRef = ref(props.message);

        if (props.message) {
            sessionStorage[`${linkageInfo.linkageName}ErrorMessage`] = messageRef.value;
        } else {
            messageRef.value = sessionStorage[`${linkageInfo.linkageName}ErrorMessage`];
        }

        return {
            messageRef,
            siteDefaultCallbackUrl,
            siteInfo,
        };
    }
});
